export const FULL_PAYMENT_CONFIRMATION_MESSAGE = "You confirm your order and pay the full amount.";
export const EVENT_HANDOVER_MESSAGE = "We hand over the equipment to you.";
export const PICKUP_HOURS_MESSAGE = "Pickup hours: 9 AM - 4 PM";
